/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ResponseCollectionString'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ResponseCollectionString'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.TimeZoneApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.ResponseCollectionString);
  }
}(this, function(ApiClient, ResponseCollectionString) {
  'use strict';

  /**
   * TimeZone service.
   * @module api/TimeZoneApi
   * @version 1.0.0
   */

  /**
   * Constructs a new TimeZoneApi. 
   * @alias module:api/TimeZoneApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getTimeZonesV1 operation.
     * @callback module:api/TimeZoneApi~getTimeZonesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseCollectionString} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a collection of timezones.
     * @param {module:api/TimeZoneApi~getTimeZonesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseCollectionString}
     */
    this.getTimeZonesV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseCollectionString;

      return this.apiClient.callApi(
        '/api/v1/timezones', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

